"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCheck = _styledComponents.default.svg.withConfig({
  displayName: "Check__StyledCheck",
  componentId: "sc-89xahv-0"
})(["animation:pop 1s linear;width:", "px;height:", "px;@keyframes pop{from{transform:scale3d(0.75,0.75,0.75);}10%,20%{transform:scale3d(0.9,0.9,0.9) rotate3d(0,0,1,-3deg);}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg);}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg);}to{transform:scale3d(1,1,1);}}"], function (props) {
  return props.size ? props.size : 30;
}, function (props) {
  return props.size ? props.size : 30;
});

var Check = function Check(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react.default.createElement(StyledCheck, {
    viewBox: "0 0 30 30",
    size: size
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15",
    fill: "#6175de"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.06152 15.4386L12.3584 19.73L21.7318 10.3568",
    fill: "none",
    stroke: "white",
    strokeWidth: "3"
  }));
};

var _default = Check;
exports.default = _default;